import React from 'react'
import {
  Button,
  Col,
  Container,
  Row,
  Table
} from 'reactstrap'
import { ListItem } from '.'
import { IgtLoader } from 'Atoms'
import { CSVLink } from "react-csv";


const CSVDataToDownloadFormat = (data) => {
  return data.map(business_unit => {
    return {
      business_unit_name: business_unit.name,
      abbreviation: business_unit.abbreviation
    }
  })
}

const BusinessUnitsList = ({ modelList, isLoading }) => {

  return (
    <Container fluid>
      {console.log(modelList)}
      <Row>
        <Col lg={{ size: 6, offset: 3 }}>
          <h1 className="text-center">Business Units Table</h1>
        </Col>
        <Col lg="3">
          <Button href="/auth/create/business_units">Add a new Business Unit</Button>{' '}
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          {
            isLoading ?
              <IgtLoader isLoading={isLoading} />
              :
              <>
              <Button style={{ margin: '5px' }} >
            {modelList && (
              <CSVLink 
              style={{color: "white"}}
                data={CSVDataToDownloadFormat(modelList)} 
                filename={'business_unit_' + new Date().toISOString() + '.csv'}
              >
                Download CSV
              </CSVLink>
            )}
          </Button>
              <Table hover>
                <thead className='sticky-header'>
                  <tr>
                    <th>Name</th>
                    <th>Abbreviation</th>
                  </tr>
                </thead>
                <tbody>
                  
                  {
                    modelList && modelList.map((business_unit, i) => {
                      return (
                        <ListItem
                          modelListItem={business_unit}
                          key={i}
                          index={i}
                        />
                      )
                    })
                  }
                </tbody>
              </Table>
              </>

          }
          
        </Col>
      </Row>
    </Container>
  )
}

export default BusinessUnitsList